import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { AuthProvider } from './context/AuthContext'
import { SystemConfigProvider } from './context/SystemConfigContext'
import { AdminAccountProvider } from './context/AdminAccountContext'
import { PendingSchoolAccountProvider } from './context/PendingSchoolAccountContext'
import { ContactProvider } from './context/ContactContext'
import { ProjectProvider } from './context/ProjectContext'
import { ToastProvider } from './context/ToastContext'
import { DotLoader } from 'react-spinners'

function AppContent() {
  return (
    <AdminAccountProvider>
      <PendingSchoolAccountProvider>
        <ContactProvider>
          <ProjectProvider>
            <ToastProvider>
              <Suspense
                fallback={
                  <div className="loading-overlay">
                    <DotLoader
                      color="var(--irogami-primary)"
                      size={40}
                      speedMultiplier={1}
                    />
                  </div>
                }
              >
                <RouterProvider router={router} future={{ v7_startTransition: true }} />
              </Suspense>
            </ToastProvider>
          </ProjectProvider>
        </ContactProvider>
      </PendingSchoolAccountProvider>
    </AdminAccountProvider>
  )
}

function App() {
  return (
    <AuthProvider>
      <SystemConfigProvider>
        <AppContent />
      </SystemConfigProvider>
    </AuthProvider>
  )
}

export default App

